import { HrefLink } from '@swaggerhub-portal/component-library'
import { useTranslation } from 'react-i18next'
import { useHydrated } from 'remix-utils/use-hydrated'

import appDefaults from '~/app.defaults.json'
import { useDarkMode } from '~/components/DarkMode/hook'
import componentErrorImageDark from '~/images/provider/product/content/api-error-dark.svg'
import componentErrorImage from '~/images/provider/product/content/api-error.svg'

export interface ComponentErrorProps {
  errorId?: string
}

export const ComponentError = ({ errorId }: ComponentErrorProps) => {
  const { t } = useTranslation()
  const { isDark } = useDarkMode()
  const isHydrated = useHydrated()
  return (
    <div className="flex items-center justify-center w-full min-h-full dark:bg-neutral-98">
      <div className="relative flex flex-col items-center gap-2 p-4">
        {isHydrated && <img src={isDark() ? componentErrorImageDark : componentErrorImage} alt={t('errors.component.label')} />}
        <h3 className="font-semibold text-body2 text-neutral-98 dark:text-neutral-20">
          {t('errors.component.label')}
        </h3>
        <p className="font-semibold text-center text-body3 text-neutral-98 dark:text-neutral-20">
          {t('errors.report.message', { id: errorId })}
        </p>
        <HrefLink
          className="font-semibold text-body3"
          href={appDefaults.support.supportRequest}
          label={t('errors.report.button.label')}
          size="small"
          isExternal={true}
          target="_blank"
        />
      </div>
    </div>
  )
}